import Vue from 'vue';
import { createExpandedSections, isLeftMenuSection, MAX_STORED_INCIDENTS } from '@/helpers/leftMenuSections';

const state = {
  expandedByIncident: {},
  incidentOrder: [],
};

const getters = {
  isSectionExpanded: (state) => (idEmergencia, section) => {
    const expandedSections = idEmergencia ? state.expandedByIncident[idEmergencia] : undefined;
    return !expandedSections || expandedSections[section] !== false;
  },
};

const mutations = {
  SET_SECTION_EXPANDED(state, { idEmergencia, section, expanded }) {
    if (!idEmergencia || !isLeftMenuSection(section)) {
      return;
    }
    if (!state.expandedByIncident[idEmergencia]) {
      Vue.set(state.expandedByIncident, idEmergencia, createExpandedSections());
    }
    state.expandedByIncident[idEmergencia][section] = expanded;
    state.incidentOrder = [idEmergencia, ...state.incidentOrder.filter((id) => id !== idEmergencia)];
    state.incidentOrder.splice(MAX_STORED_INCIDENTS).forEach((id) => {
      Vue.delete(state.expandedByIncident, id);
    });
  },
};

const actions = {
  toggleSection({ commit, getters }, { idEmergencia, section }) {
    commit('SET_SECTION_EXPANDED', {
      idEmergencia,
      section,
      expanded: !getters.isSectionExpanded(idEmergencia, section),
    });
  },
};

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default module;
